/*************************************************************************
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { inject } from "mobx-react";
import { getHCColorPalleteObservable } from "selectors/highContrastSelectors";
import TileCanvas from "components/document/page/TileCanvas";

const mapStoresToProps = (stores, props) => ({
  height: props.height,
  width: props.width,
  hcColorPalette: getHCColorPalleteObservable(stores),
  setTileCanvasRef: canvasRef => stores.pagedViewState.setTileCanvasRef(props.pageIndex, canvasRef)
});

const TileCanvasContainer = inject(mapStoresToProps)(TileCanvas);
export default TileCanvasContainer;
